'use strict';

import angular from 'angular';
import ShowController from './show.controller';

export default angular.module('updateServerApp.appstore.show', [])
  .controller('AppStoreShowController', ShowController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appstore/show/index.js